import { AccessorsMutatorsDecorator, Model } from '../../../helpers';
import { Property } from '../property.model';

export class ReceiptVoucher extends Model {


}

AccessorsMutatorsDecorator('id', 'property_id', 'voucher_id', 'created_at', 'created_at_tz', 'source_internal', 'source', 'guest_id', 'amount', 'received_from',
    'payment_method_internal', 'payment_method', 'reservation_id', 'reservation_ident', 'house_account_id', 'house_account_name', 'purpose',
    'user_id', 'user_name', 'voided_at', 'voided_by', 'status', 'house_account_formatted')(ReceiptVoucher);



// WEBPACK FOOTER //
// ./src/pms-api/models/vouchers/receipt-voucher.model.js